import type { BijlageMime, MeldBijlage } from './types';

/** P3: longest side at most 1600 px; PriceQ and Qontrol both refuse more than 2 MB. */
export const MAX_ZIJDE = 1600;
export const MAX_BYTES = 2 * 1024 * 1024;

const POGINGEN: ReadonlyArray<readonly [BijlageMime, number]> = [
  ['image/webp', 0.8],
  ['image/jpeg', 0.8],
  ['image/jpeg', 0.6],
];

export function schaalMaat(w: number, h: number, max = MAX_ZIJDE): { w: number; h: number } {
  const f = Math.min(1, max / Math.max(w, h, 1));
  return { w: Math.max(1, Math.round(w * f)), h: Math.max(1, Math.round(h * f)) };
}

export async function blobNaarBase64(blob: Blob): Promise<string> {
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let bin = '';
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(bin);
}

function naarBlob(c: Pick<HTMLCanvasElement, 'toBlob'>, type: string, kwaliteit: number): Promise<Blob | null> {
  return new Promise((klaar) => c.toBlob(klaar, type, kwaliteit));
}

export async function naarBijlage(c: Pick<HTMLCanvasElement, 'toBlob'>, gemaskeerd: boolean): Promise<MeldBijlage | null> {
  for (const [mime, kwaliteit] of POGINGEN) {
    const blob = await naarBlob(c, mime, kwaliteit);
    // A browser that cannot encode WebP silently returns a PNG: check the type it really made.
    if (blob && blob.type === mime && blob.size <= MAX_BYTES) {
      return { mime, inhoud_base64: await blobNaarBase64(blob), gemaskeerd };
    }
  }
  return null;
}

function isBijlageMime(t: string): t is BijlageMime {
  return t === 'image/png' || t === 'image/jpeg' || t === 'image/webp';
}

export async function bestandNaarBijlage(f: File): Promise<MeldBijlage | null> {
  if (!isBijlageMime(f.type) || f.size > MAX_BYTES) return null;
  return { mime: f.type, inhoud_base64: await blobNaarBase64(f), gemaskeerd: false };
}
